/* tslint:disable */

import * as React from 'react';
import './Store.less';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { StoreState } from '@ui/store/rootReducer';
import { storeSelectors } from '..';
import * as actions from '../services/actions';
import * as metaActions from '@ui/store/meta/actions';
import { LoadableContent, PageNavigation, Separator } from '@ui/components';
import CollectionPanel from '../components/CollectionPanel';
import CollectionCard from '../components/CollectionCard';
import { authSelectors } from '@ui/store/auth';
import { Button, Icon, Input, Tag } from 'antd';
import storePng from '@ui/assets/store.png';
import { debounce } from 'lodash';
import { metaSelectors } from '@ui/store/meta';
import { getApiUrl } from '../../../utils/config';
import { Fragment } from 'react';
import { IFocus } from '@ui/store/meta/actions';
import { collectionApi } from '@ui/api/collection';
import { storeApi } from '@ui/api/store';
import { EditReference } from '../../../components/EditReference';

interface IState {
  collections: any[];
  activeTab: number;
  storeId: string;
  hasEdit: number;
  hasEditMap: any[];
  comment: string;
  collectionsWithFocus: any[];
  isEditReferenceVisible: boolean;
  isEditingStore: boolean; // Added this line
  editedAddress?: string,
  editedPhone?: string,
  editedMail?: string,
  editedFirstName?: string,
  editedMiddleName?: string,
  editedLastName?: string,
  editedFirstContactPhone?: string,
  editedSecondContactPhone?: string,
  editedStoreName?: string, // Added this line
}

interface StateToProps {
  store: any;
  loading: boolean;
  user: any;
  historyCollections: any[];
  collections: any[];
}

interface DispatchToProps {
  onLoadStore: (storeId: string) => void;
  saveRequest: (request: any, collections: any[]) => void;
  updateComment: (storeId: string, comment: string) => void;
  updateFocus: (focus: IFocus) => void;
}

type Props = RouteComponentProps & StateToProps & DispatchToProps;

class Store extends React.Component<Props, IState> {
  state: IState = {
    collections: [],
    activeTab: 0,
    storeId: '',
    hasEdit: 0,
    hasEditMap: [],
    comment: '',
    collectionsWithFocus: [],
    isEditReferenceVisible: false,
    isEditingStore: false,
    editedAddress: undefined,
    editedPhone: undefined,
    editedMail: undefined,
    editedFirstName: undefined,
    editedMiddleName: undefined,
    editedLastName: undefined,
    editedFirstContactPhone: undefined,
    editedSecondContactPhone: undefined,
    editedStoreName: undefined, // Added this line
  };

  componentDidMount(): void {
    const { match, onLoadStore } = this.props;
    const { storeId } = match.params as any;

    onLoadStore(storeId);
    void this.fetchCollectionsWithFocus(storeId);
  }

  private async fetchCollectionsWithFocus(storeId: number) {
    const { collections } = await collectionApi.getCollectionsWithFocus(storeId).toPromise();
    this.setState({
      collectionsWithFocus: collections,
    });
  }

  static getDerivedStateFromProps(props: Props, state: any) {
    if (!props.store) {
      return null;
    }

    if (!state.collections.length || state.storeId !== props.store.id.toString()) {
      return {
        collections: props.store.collections,
        storeId: props.store.id.toString(),
        comment: props.store.comment || '',
      };
    }

    return null;
  }
  handleChangeTab = (id: any, length: any, type: any) => {
    // копируем значение из стейта
    let value = this.state.activeTab;

    // добавляем
    if (id !== null) {
      value === id;
    }

    // проверка на типа

    if (type === '-') {
      value = value - 30;
    } else if (type === '+') {
      value = value + 30;
    }

    // проверка допустимого значения

    if (value < 0 || value > length - 1) {
      return;
    }

    // изменяем стейт

    this.setState({
      activeTab: value,
    });
  };
  handleSetHasEdit = () => {
    const { hasEdit } = this.state;
    this.setState({ hasEdit: hasEdit + 1 });
  };

  handleChangeStatusCollection = (collectionId: string, status: boolean) => {
    const { collections } = this.state;
    const newCollections = collections.map((collection: any) => {
      if (collection.collection.id === collectionId) {
        return { ...collection, status };
      }

      return collection;
    });
    this.setState((state: any) => ({
      collections: newCollections,
      hasEditMap: [...state.hasEditMap, collectionId],
    }));
  };

  handleSetStatusToWholeCollection = () => {
    const { collections, hasEditMap } = this.state;
    let newHasEditMap = [...hasEditMap];
    const newCollections = collections.map((collection: any) => {
      if (!newHasEditMap.includes(collection.collection.id)) {
        newHasEditMap.push(collection.collection.id);
      }
      if (!collection.status) {
        return { ...collection, status: true };
      }
      return collection;
    });
    this.setState((state: any) => ({
      collections: newCollections,
      hasEditMap: newHasEditMap,
      hasEdit: newCollections.length,
    }));
  };

  handleSaveRequest = () => {
    const { collections } = this.state;
    const { saveRequest, store, user } = this.props;

    this.setState({ hasEdit: 0, hasEditMap: [] });

    saveRequest({ store: store.id, user: user.id }, collections);
  };

  handleClickBack = () => {
    const { history, store } = this.props;

    history.push(`/city/${store.city.id}/stores`);
  };

  handleGoToOblastj = () => {
    const { history, store } = this.props;

    history.push(`/region/${store.city.region.id}`);
  }

  setComment = (evt: React.ChangeEvent<HTMLTextAreaElement>) => {
    this.setState({ comment: evt.target.value });
    this.updateComment(evt.target.value);
  };

  updateComment = debounce((comment: string) => {
    const { store, updateComment } = this.props;
    updateComment(store.id, comment);
  }, 300);

  onFocusChange(evt: React.ChangeEvent<HTMLInputElement>, collectionId: number) {
    const { store } = this.props;
    const { value, name, id } = evt.target;
    const focus: IFocus = {
      storeId: store.id,
      collectionId,
    };

    if (id) {
      focus.id = Number(id);
    }

    if (name === 'wanted') {
      focus.wanted = value;
    } else {
      focus.disliked = value;
    }

    void this.updateFocus(focus);
  }

  updateFocus = debounce(async (focus: IFocus) => {
    const updatedFocus = await storeApi.updateFocus(focus).toPromise();
    this.setState((state) => ({
      collectionsWithFocus: state.collectionsWithFocus.map((c) => {
        if (c.id === updatedFocus.collectionId) {
          return {
            ...c,
            focus: {
              ...c.focus,
              id: updatedFocus.id,
            },
          };
        }
        return c;
      }),
    }));
  }, 300);

  showIsEditReferenceModal = () => {
    this.setState({
      isEditReferenceVisible: true,
    });
  };

  hideIsEditReferenceModal = () => {
    this.setState({
      isEditReferenceVisible: false,
    });
  };

  toggleEditStore = () => {
    const { isEditingStore, editedAddress, editedPhone, editedMail, editedFirstName, editedMiddleName, editedLastName, editedFirstContactPhone, editedSecondContactPhone, editedStoreName } = this.state;
    if (isEditingStore) {
      const { store } = this.props;
      const updatedStore = {
        ...store,
        address: editedAddress !== undefined ? editedAddress : store.address,
        phone: editedPhone !== undefined ? editedPhone : store.phone,
        mail: editedMail !== undefined ? editedMail : store.mail,
        firstName: editedFirstName !== undefined ? editedFirstName : store.firstName,
        middleName: editedMiddleName !== undefined ? editedMiddleName : store.middleName,
        lastName: editedLastName !== undefined ? editedLastName : store.lastName,
        firstContactPhone: editedFirstContactPhone !== undefined ? editedFirstContactPhone : store.firstContactPhone,
        secondContactPhone: editedSecondContactPhone !== undefined ? editedSecondContactPhone : store.secondContactPhone,
        name: editedStoreName !== undefined ? editedStoreName : store.name, // Added this line
      };
      this.updateStore(updatedStore);
    }
    this.setState((prevState) => ({ isEditingStore: !prevState.isEditingStore }));
  };

  updateStore = debounce(async (store: any) => {
    await storeApi.updateStoreInfo(store.id, store).toPromise();
  }, 300);

  handleAddressChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ editedAddress: e.target.value });
  };

  handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ editedPhone: e.target.value });
  }

  handleMailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ editedMail: e.target.value });
  }

  handleFirstNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ editedFirstName: e.target.value });
  }

  handleMiddleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ editedMiddleName: e.target.value });
  }

  handleLastNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ editedLastName: e.target.value });
  }

  handleFirstContactPhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ editedFirstContactPhone: e.target.value });
  }

  handleSecondContactPhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ editedSecondContactPhone: e.target.value });
  }

  // Add a handler for the store name change
  handleStoreNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ editedStoreName: e.target.value });
  };

  render() {
    const { loading, store, historyCollections } = this.props;

    const {
      collections: rawCollections,
      hasEdit,
      hasEditMap,
      comment,
      collectionsWithFocus,
      isEditReferenceVisible,
      isEditingStore,
      editedStoreName, // Added this line
    } = this.state;
    const collections = (rawCollections || []).sort((a: any, b: any) =>
      a.collection.name < b.collection.name ? -1 : 1,
    );

    let collectionsPagination = [];
    const chunk = 1000;

    for (let i = 0, j = collections.length; i < j; i += chunk) {
      collectionsPagination[i] = collections.slice(i, i + chunk);
    }
    const noCollections = collections.filter((collection: any) => !collection.status).length;

    const yesCollections = collections.filter((collection: any) => collection.status).length;

    // @ts-ignore
    return (
      <LoadableContent loading={loading}>
        <EditReference isVisible={isEditReferenceVisible} hideIsEditReferenceModal={this.hideIsEditReferenceModal} />
        {store && (
          <div className="store-page">
            <div className="store-page__content">
              <PageNavigation
                style={{ width: '100%' }}
                title={
                  <div className="city-stores-panel">
                    <span onClick={this.handleGoToOblastj}>{store.city.region.name}</span>
                    <Separator />
                    <span onClick={this.handleClickBack}>{store.city.name}</span>
                    <Separator />
                    <span>{store.name}</span>
                  </div>
                }
              />
              <div className="store-page__panel-name">
                <Button className="store-page__panel-name__button" onClick={this.handleClickBack}>
                  <Icon type="arrow-left" />
                  <span>{store.city.name}</span>
                </Button>
                <div className="store-page__meta__desc__name">
                  <span>
                    {isEditingStore ? (
                      <Input
                        defaultValue={editedStoreName !== undefined ? editedStoreName : store.name}
                        onChange={this.handleStoreNameChange}
                        style={{ width: '600px' }}
                      />
                    ) : (
                      <span>{editedStoreName !== undefined ? editedStoreName : store.name}</span>
                    )}
                  </span>
                </div>
              </div>
              <div className="store-page__container">
                <div className="store-page__meta">
                  <div className="store-page__meta__photo">
                    {store.photo ? (
                      <img src={`${getApiUrl()}/store/${store.id}/get-photo`} width="100%" height="100%" alt="" />
                    ) : (
                      <img src={storePng} width="100%" height="100%" alt="" />
                    )}
                  </div>
                  <div className="store-page__meta__info">
                    <div className="store-page__meta__desc">
                      <div className="store-page__meta__desc__info">
                        <span>
                          <span>Адрес:</span>
                          {isEditingStore ? (
                            <Input defaultValue={this.state.editedAddress !== undefined ? this.state.editedAddress : store.address} onChange={this.handleAddressChange} />
                          ) : (
                            <span>{this.state.editedAddress !== undefined ? this.state.editedAddress : store.address}</span>
                          )}
                        </span>
                        <span>
                          <span>Телефон:</span>
                          {isEditingStore ? (
                            <Input defaultValue={this.state.editedPhone !== undefined ? this.state.editedPhone : store.phone} onChange={this.handlePhoneChange} />
                          ) : (
                            <span>
                              <a href={`tel:${this.state.editedPhone !== undefined ? this.state.editedPhone : store.phone}`}>{this.state.editedPhone !== undefined ? this.state.editedPhone : store.phone}</a>
                            </span>
                          )}
                        </span>
                        <span>
                          <span>email:</span>{' '}
                          {isEditingStore ? (
                            <Input defaultValue={this.state.editedMail !== undefined ? this.state.editedMail : store.mail} onChange={this.handleMailChange} />
                          ) : (
                            <span>
                              <a href={`mailto:${this.state.editedMail !== undefined ? this.state.editedMail : store.mail}`}>{this.state.editedMail !== undefined ? this.state.editedMail : store.mail}</a>
                            </span>
                          )}
                        </span>
                        <span>
                          <span>Фабрики: </span>
                          <span>{store.factories.map((factory: any) => `${factory.name}, `)}</span>
                        </span>
                        <span>
                          <span>Комментарий:</span>
                          <span className="store-page__meta__desc__info__comment_textarea_wrapper">
                            <textarea value={comment} onChange={this.setComment} name="comment" id="comment" rows={3} />
                          </span>
                        </span>
                        <span>
                          <Button onClick={this.toggleEditStore}>{isEditingStore ? 'Сохранить магазин' : 'Редактировать магазин'}</Button>
                        </span>
                        <span>
                          <span>Фокус:</span>
                          <span className="store-page__meta__focus">
                            {collectionsWithFocus
                              .filter(
                                (c) => collections.findIndex(({ collection }: any) => collection.id === c.id) === -1,
                              )
                              .map((c) => (
                                <Fragment key={c.id}>
                                  <Tag className="store-page__meta__desc__info__tag">{c.name}</Tag>
                                  <div className="store-page__meta__focus__inputs">
                                    <Input
                                      id={c.focus && c.focus.id}
                                      onChange={(evt) => this.onFocusChange(evt, c.id)}
                                      defaultValue={c.focus ? c.focus.disliked : ''}
                                      placeholder="Что не понравилось"
                                      name="disliked"
                                      type="text"
                                    />
                                    <Input
                                      id={c.focus && c.focus.id}
                                      defaultValue={c.focus ? c.focus.wanted : ''}
                                      onChange={(evt) => this.onFocusChange(evt, c.id)}
                                      placeholder="Чего бы хотелось"
                                      name="wanted"
                                      type="text"
                                    />
                                  </div>
                                </Fragment>
                              ))}
                          </span>
                        </span>
                        <span>
                          <span />
                          <Button className="store-page__meta__desc__info__save-focus-button">Сохранить фокус</Button>
                        </span>
                        <span>
                          <Button onClick={this.showIsEditReferenceModal}>Редактировать эталон</Button>
                        </span>
                      </div>
                    </div>
                    <div className="store-page__meta__contact">
                      <span>Контактное лицо</span>
                      <span className="store-page__meta__contact__name">
                        {isEditingStore ? (
                          <>
                            <Input defaultValue={this.state.editedFirstName !== undefined ? this.state.editedFirstName : store.firstName} onChange={this.handleFirstNameChange} placeholder="Имя" />
                            <Input defaultValue={this.state.editedMiddleName !== undefined ? this.state.editedMiddleName : store.middleName} onChange={this.handleMiddleNameChange} placeholder="Отчество" />
                          </>
                        ) : (
                          <span>
                            {this.state.editedFirstName !== undefined ? this.state.editedFirstName : store.firstName} {this.state.editedMiddleName !== undefined ? this.state.editedMiddleName : store.middleName}
                          </span>
                        )}
                        {isEditingStore ? (
                          <Input defaultValue={this.state.editedLastName !== undefined ? this.state.editedLastName : store.lastName} onChange={this.handleLastNameChange} placeholder="Фамилия" />
                        ) : (
                          <span>{this.state.editedLastName !== undefined ? this.state.editedLastName : store.lastName}</span>
                        )}
                      </span>

                          {isEditingStore ? (
                            <Input defaultValue={this.state.editedFirstContactPhone !== undefined ? this.state.editedFirstContactPhone : store.firstContactPhone} onChange={this.handleFirstContactPhoneChange} placeholder="Телефон 1" />
                          ) : (
                            <a href={`tel:${this.state.editedFirstContactPhone !== undefined ? this.state.editedFirstContactPhone : store.firstContactPhone}`}>{this.state.editedFirstContactPhone !== undefined ? this.state.editedFirstContactPhone : store.firstContactPhone}</a>
                          )}
                          {isEditingStore ? (
                            <Input defaultValue={this.state.editedSecondContactPhone !== undefined ? this.state.editedSecondContactPhone : store.secondContactPhone} onChange={this.handleSecondContactPhoneChange} placeholder="Телефон 2" />
                          ) : (
                            <a href={`tel:${this.state.editedSecondContactPhone !== undefined ? this.state.editedSecondContactPhone : store.secondContactPhone}`}>{this.state.editedSecondContactPhone !== undefined ? this.state.editedSecondContactPhone : store.secondContactPhone}</a>
                          )}
                    </div>
                  </div>
                </div>
                <div className="store-page__collections">
                  <CollectionPanel
                    noCollections={noCollections}
                    yesCollections={yesCollections}
                    allCollections={collections.length}
                    onSetStatusToWholeCollection={this.handleSetStatusToWholeCollection}
                    onSave={this.handleSaveRequest}
                    disableSendRequest={hasEdit !== collections.length}
                    historyCollections={historyCollections}
                  />
                  {/* <div className="buttonsstore">
                    <button onClick={() => this.handleChangeTab(null, collectionsPagination.length, '-')}>
                      ← Предыдущая
                    </button>
                    <p>
                      {this.state.activeTab / 30 + 1}/{(collectionsPagination.length + 29) / 30}
                    </p>
                    <button onClick={() => this.handleChangeTab(null, collectionsPagination.length, '+')}>
                      Следующая →
                    </button>
                  </div> */}
                  <div className="store-page__collections__div">
                    {collectionsPagination.map((collections, activeIndex) => {
                      return (
                        <>
                          {activeIndex === this.state.activeTab &&
                            collections.map(
                              (
                                {
                                  collection,
                                  status,
                                }: {
                                  collection: any;
                                  status: boolean;
                                },
                                index,
                              ) => {
                                return (
                                  <CollectionCard
                                    key={`${store.id}-${collection.id}`}
                                    collection={collection}
                                    historyCollection={historyCollections[activeIndex + index]}
                                    status={status}
                                    onChangeStatus={this.handleChangeStatusCollection}
                                    setHasEdit={this.handleSetHasEdit}
                                    hasEditDefault={hasEditMap.includes(collection.id) as any}
                                  />
                                );
                              },
                            )}
                        </>
                      );
                    })}
                  </div>
                  {/* <div className="buttonsstore">
                    <button onClick={() => this.handleChangeTab(null, collectionsPagination.length, '-')}>
                      ← Предыдущая
                    </button>
                    <p>
                      {this.state.activeTab / 30 + 1}/{(collectionsPagination.length + 29) / 30}
                    </p>
                    <button onClick={() => this.handleChangeTab(null, collectionsPagination.length, '+')}>
                      Следующая →
                    </button>
                  </div> */}
                  <CollectionPanel
                    noCollections={noCollections}
                    yesCollections={yesCollections}
                    allCollections={collections.length}
                    onSetStatusToWholeCollection={this.handleSetStatusToWholeCollection}
                    onSave={this.handleSaveRequest}
                    disableSendRequest={hasEdit !== collections.length}
                    historyCollections={historyCollections}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </LoadableContent>
    );
  }
}

const mapStateToProps = (state: StoreState): StateToProps => ({
  store: storeSelectors.getStore(state),
  loading: storeSelectors.getLoading(state),
  user: authSelectors.getUser(state),
  historyCollections: storeSelectors.getHistoryCollections(state),
  collections: metaSelectors.getCollections(state),
});

const mapDispatchToProps: DispatchToProps = {
  onLoadStore: actions.storeRequested,
  saveRequest: actions.saveRequestRequested,
  updateComment: actions.updateComment,
  updateFocus: metaActions.updateFocus,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Store));



// WEBPACK FOOTER //
// ./src/scenes/Store/containers/Store.tsx